import {
    combinedIntakeOpenloopFormId,
    genericSunnysideMedDiagnosticFormId,
    glp1DiagnosticFormId,
    naltrexoneOnlyDiagnosticFormId,
    naltrexoneOnlyIntakeOpenloopFormId,
    naltrexoneOnlyRefillFormId,
    naltrexoneOnlyRefillOpenloopFormId,
    naltrexoneOnlyUpsellDiagnosticFormId,
    naltrexoneOnlyUpsellIntakeFormId,
    naltrexoneOnlyV2DiagnosticFormId,
    naltrexoneFirstV2RecommendationDiagnosticFormId,
    naltrexoneV2RecommendationDiagnosticFormId,
    genericAdSafeSunnysideMedDiagnosticFormId,
    naltrexoneOnlyV2RefillFormId,
    naltrexoneOnlyV2RefillOpenloopFormId,
    glp1RefillFormId,
    glp1RefillOpenloopFormId
} from '../../logic/auth';

export const mapFormIdToOpenloopFormId = (formId: string): string => {
    switch (formId) {
    case naltrexoneOnlyUpsellDiagnosticFormId:
    case naltrexoneOnlyUpsellIntakeFormId:
    case naltrexoneOnlyDiagnosticFormId:
    case naltrexoneOnlyV2DiagnosticFormId:
        return naltrexoneOnlyIntakeOpenloopFormId;
    case naltrexoneOnlyRefillFormId:
        return naltrexoneOnlyRefillOpenloopFormId;
    case glp1DiagnosticFormId:
    case genericSunnysideMedDiagnosticFormId:
    case genericAdSafeSunnysideMedDiagnosticFormId:
    case naltrexoneFirstV2RecommendationDiagnosticFormId:
    case naltrexoneV2RecommendationDiagnosticFormId:
        return combinedIntakeOpenloopFormId;
    case naltrexoneOnlyV2RefillFormId:
        return naltrexoneOnlyV2RefillOpenloopFormId;
    case glp1RefillFormId:
        return glp1RefillOpenloopFormId;
    default:
        return naltrexoneOnlyIntakeOpenloopFormId;
    }
};
